import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import _ from "lodash";
import {
  getCoursesWithHigherSubscription,
  getCoursesWithHigherSubscriptionClear,
  getCoursesWithPaidSubscription,
  getCoursesWithPaidSubscriptionClear,
  getProductCategoriesData,
  getProductCategoriesDataClear,
} from "../../../redux/courses/actions";
import {
  PriceForSession,
  ProductCardPriceInfo,
  PurchasedOn,
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  getProcureInfo,
  redirectToPageUtil,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router";
import CommonComponentEntity from "./CommonComponentEntity";
import useLogin from "../../../custom-hooks/useLogin";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import PrevArrow from "../../LearningPaths/PrevArrow";
import NextArrow from "../../LearningPaths/NextArrow";
import Slider from "react-slick";

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  dots: false,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const CoursesIncludedWithSubscription = ({
  fetchData,
  currentSubscription,
  is_home,
  from_sub,
}) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const coursesIncludedWithSubscription = useSelector(
    (state) => state.courses.coursesWithPaidSubscription
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (fetchData) getCoursesWithPaidSubscriptionData();

    return () => {
      dispatch(getCoursesWithPaidSubscriptionClear());
    };
  }, [fetchData]);

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA
  );

  const [paidUserCount, setPaidUserCount] = useState(0);
  const { isLoggedIn } = useLogin();
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [courseData, setCourseData] = useState({});

  const formatProductCardData = (coursesList) => {
    let prodArr = [];
    for (let course of coursesList) {
      let tags = [];
      let btnTitle = "Start course";
      if (course.provider?.provider_display_name) {
        tags.push(course.provider.provider_display_name);
      }
      tags.push("Course");

      if (course.lessons) {
        tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
      }

      if (course?.duration) {
        tags.push(convertTimeFormat(course.duration, true));
      }

      if (
        (course?.source === "ecom" || course?.source === "xsel") &&
        !course?.purchased_info?.is_purchased &&
        course?.purchased_info?.selling_price != 0
      ) {
        btnTitle = "Explore";
      } else if (
        course.crs_progress === "" ||
        course.crs_progress === undefined ||
        course.crs_progress === null ||
        course.crs_progress === 0
      ) {
        btnTitle = "Start course";
      } else if (course.crs_progress > 0 && course.crs_progress < 100) {
        btnTitle = "Resume course";
      } else if (course.crs_progress >= 100) {
        btnTitle = "Revisit course";
      }

      let priceInfo = getProcureInfo(course?.purchased_info);
      course.priceInfo = priceInfo;
      course.isLoggedIn = isLoggedIn;
      course.is_home = is_home;
      course.from_sub = from_sub;
      course.provider_id = "";

      prodArr.push({
        id: course?.id,
        is_like: course?.is_like ? course?.is_like : false,
        is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
        is_wishlist: course?.is_addtowishlist,
        dbId: course?.list_id,
        productType: "course",
        productOrigin: course?.source,
        title: course?.name,
        logoURL: course.provider?.provider_img
          ? course.provider?.provider_img
          : "",
        bannerURL: course?.imageURL,
        tagsArray: tags,
        description: course?.short_description,
        btnTitle: btnTitle,
        progress: course?.crs_progress,
        showLikeMenu: true,
        btnAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        descAction: {},
        bannerAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        showHeader: true,
        showProviderIcon: true,
        showBody: course?.short_description ? true : false,
        showFooter: true,
        showProgress: _.toNumber(course.crs_progress) > 0 ? true : false,
        cardClassName: "",
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isLoading: false,
        priceInfo,
        show4: true,
      });
    }
    console.log("PROD ARR", prodArr);
    setNewCardData(prodArr);
  };

  useEffect(() => {
    if (!_.isEmpty(coursesIncludedWithSubscription)) {
      if (coursesIncludedWithSubscription.status === "success") {
        const list1 =
          coursesIncludedWithSubscription.payload.payload?.courseList;
        if (!_.isEmpty(list1)) {
          setPaidUserCount(
            coursesIncludedWithSubscription.payload.payload?.user_count
          );
          formatProductCardData(list1);
          setIsLoading(false);
        } else {
          setNewCardData([]);
          setIsLoading(false);
        }
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    }
  }, [coursesIncludedWithSubscription]);

  const getCoursesWithPaidSubscriptionData = () => {
    setNewCardData(CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getCoursesWithPaidSubscription({
        module: "coursesWithPaidSubscription",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
        },
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      {/* <CommonComponentEntity
        newCardData={newCardData}
        heading={`Courses included with ${
          localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? currentSubscription
              ? currentSubscription
              : "Starter"
            : ""
        }  subscription`}
        subHeading={`👍🏻  ${paidUserCount}+ learners have subscribed`}
        viewAllAction={"/learn/courses?tab=1"}
        type={"course"}
      /> */}
      <section className="recommended-section pt-5">
        <div className="container">
          {!_.isEmpty(newCardData) && (
            <div className="row">
              <div className="col-md-8 col-12">
                <div className="subscriptions-row">
                  {isLoading ? (
                    <h3 className="subs-course-title">
                      <ShimmerScreen case="rect" height="2rem" width="30rem" />
                    </h3>
                  ) : (
                    <h3 className="subs-course-title">
                      {`Courses included with ${
                        localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                          ? currentSubscription
                            ? currentSubscription
                            : "Starter"
                          : ""
                      }  subscription`}
                    </h3>
                  )}
                  {true ? (
                    ""
                  ) : isLoading ? (
                    <span className="subscriptions-subhead">
                      <ShimmerScreen case="rect" height="1rem" width="10rem" />
                    </span>
                  ) : (
                    <span className="subscriptions-subhead"></span>
                  )}
                </div>
              </div>
              <div className="col-md-4 col-12 text-md-end">
                {isLoading ? (
                  <button type="button" className="view-all-btn">
                    <ShimmerScreen case="rect" height="3rem" width="7rem" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="view-all-btn"
                    onClick={() => {
                      navigate("/learn/courses?tab=1");
                    }}
                  >
                    View all
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                        stroke="#6941C6"
                        strokeWidth="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                )}
              </div>
            </div>
          )}
          <div className="row recommend-slide">
            <Slider {...settings}>
              {newCardData?.length === 0
                ? ""
                : newCardData.map((video, i) => {
                    return (
                      <ProductCardComponent {...video} key={`video-${i + 1}`} />
                    );
                  })}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoursesIncludedWithSubscription;
